export default __webpack_public_path__ + "static/media/icon-Lyra_sm.56a6eb58.svg";